import type { PortableTextComponents } from 'next-sanity'

import { Icon } from '@/app/components/Icon'

export const createPortableTextLists = (): Pick<PortableTextComponents, 'list' | 'listItem'> => ({
  list: {
    bullet: ({ children }) => (
      <ul className="my-3xl lg:my-5xl flex flex-col gap-md [&_ul]:mt-md [&_ul]:my-0 size-body-sm lg:size-body-md">
        {children}
      </ul>
    ),
    number: ({ children }) => (
      <ol className="my-3xl lg:my-5xl flex flex-col gap-md [counter-reset:item] [&_ol]:mt-md [&_ol]:ml-0 md:[&_ol]:ml-md [&_ol]:my-0 [&_ol]:[counter-reset:item] size-body-sm lg:size-body-md">
        {children}
      </ol>
    ),
    checked: ({ children }) => (
      <ul className="my-3xl lg:my-5xl flex flex-col gap-md [&_ul]:mt-md [&_ul]:my-0 size-body-sm lg:size-body-md">
        {children}
      </ul>
    ),
  },
  listItem: {
    bullet: ({ children }) => (
      <li className="flex gap-sm [&_a]:text-primary-700 [&_a]:underline">
        <span className="text-primary-700 [ul_ul_&]:text-primary-200 font-bold">•</span>
        <span className="flex-1">{children}</span>
      </li>
    ),
    number: ({ children }) => (
      <li className="flex gap-sm [counter-increment:item] before:content-[counter(item)'.'] before:text-primary-700 before:font-bold [ol_&]:before:content-[counters(item,'.')'.'] [&_a]:text-primary-700 [&_a]:underline">
        <span className="flex-1">{children}</span>
      </li>
    ),
    checked: ({ children }) => (
      <li className="flex gap-sm [&_a]:text-primary-700 [&_a]:underline">
        <Icon
          name="faCircleCheck"
          provider="fontawesome"
          style="solid"
          size={16}
          className="text-primary-700 [ul_ul_&]:text-primary-200 mt-[3px]"
        />
        <span className="flex-1">{children}</span>
      </li>
    ),
  },
})
